import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=aa44f4b4&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa44f4b4')) {
      api.createRecord('aa44f4b4', component.options)
    } else {
      api.reload('aa44f4b4', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=aa44f4b4&", function () {
      api.rerender('aa44f4b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ssG4L5bpdwiN/JS/comp/starrating.vue"
export default component.exports